import Form from "../forms/form";
import MyCountdown from "../parts/countdown";
import { MdPlace } from "react-icons/md";
import { FaPhone } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import ScrollAnimation from 'react-animate-on-scroll';
import 'animate.css';
import yellowLinies from '../../img/yellow-linies.png'
import React from "react";

function LeadMagnetOne() {

    return (
        <>
            <section className="mb-20 relative">
                <div className="container max-w-screen-lg mx-auto relative z-20 bg-white">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 border-2 border-[#001D53] rounded-2xl overflow-hidden">

                        <div className="bg-[#001D53] py-6 p-2 sm:p-9">
                            <ScrollAnimation animateIn="animate__fadeInUp">
                            <div className="sm:flex flex-wrap items-center gap-[20px] pb-[20px] text-[#e7e9ec] border-b border-white/30 last:border-0 last:pb-0 mb-8">
                                <span className="icon shrink-0 bg-[#003366] rounded-full h-[62px] w-[62px] flex items-center justify-center mb-4 sm:mb-0 text-2xl">
                                    <FaPhone />
                                </span>

                                <div className="txt txt-form w-[calc(100%-82px)]">
                                    <span className="font-light block text-[14px] mb-[12px]">Персональна консультація</span>
                                    <h4 className="font-semibold text-[18px] sm:text-[24px]"><a href="tel:+380672230179" className="form_cons_clk">+38 (067) 223 01 79</a></h4>
                                </div>
                            </div>
                            </ScrollAnimation>
                            <ScrollAnimation animateIn="animate__fadeInUp">
                            <div className="sm:flex flex-wrap items-center gap-[20px] pb-[20px] text-[#e7e9ec] border-b border-white/30 last:border-0 last:pb-0 mb-8">
                                <span className="icon shrink-0 bg-[#003366] rounded-full h-[62px] w-[62px] flex items-center justify-center mb-4 sm:mb-0 text-2xl">
                                    <MdEmail />
                                </span>

                                <div className="txt txt-form w-[calc(100%-82px)]">
                                    <span className="font-light block text-[14px] mb-[12px]">Напишіть нам</span>
                                    <h4 className="font-semibold text-[18px] sm:text-[24px]"><a className="form_cons_clk_1"  href="mailto:tickets@ekonomika.ua">tickets@ekonomika.ua</a>
                                    </h4>
                                </div>
                            </div>
                            </ScrollAnimation>
                            <ScrollAnimation animateIn="animate__fadeInUp">
                            <div  className="sm:flex flex-wrap items-start gap-[20px] pb-[20px] text-[#e7e9ec] border-b border-white/30 last:border-0 last:pb-0">
                                <span className="icon shrink-0 bg-[#003366] rounded-full h-[62px] w-[62px] flex items-center justify-center mb-4 sm:mb-0 text-2xl">
                                    <MdPlace />
                                </span>

                                <div className="txt txt-form w-[calc(100%-82px)]">
                                    <span className="font-light block text-[14px] mb-[12px]">Локація</span>
                                    <h4 className="text-[16px] leading-[1.25]">Задля вашої безпеки місце проведення Business Wisdom Summit 2025 буде повідомлено учасникам напередодні заходу. Ми подбали про те, щоб створити максимально комфортні та безпечні умови.</h4>
                                </div>
                            </div>
                            </ScrollAnimation>

                        </div>

                        <div className="pb-6 p-2 sm:p-9">
                            <ScrollAnimation animateIn="animate__fadeInUp"><h4 className="text-2xl mb-5">Дієві стратегії для лідерів 2025</h4></ScrollAnimation>
                            <ScrollAnimation animateIn="animate__fadeInUp"><p className="mb-5"><b>Business Wisdom Summit 2025</b> – це не лише про знання, а й про визнання лідерів, які змінюють правила гри. Будьте серед перших, хто дізнається, хто увійшов до списку найкращих керівників України за версією «ТОП-100. Рейтинги найбільших».</p></ScrollAnimation>
                            <MyCountdown />
                            <Form />
                        </div>
                    </div>
                </div>
                <div className="!bg-contain w-full h-full absolute top-0 left-0 z-10" style={{background: "url("+ yellowLinies + ")"}}></div>
            </section>
        </>
    )
}

export default LeadMagnetOne